import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Configuration } from '@common/models/configuration';
import * as AppGlobals from '@apps/globals';

import { AppModule } from './app/app.module';
import { configuration } from './config/configuration';

function startApp(config?: Configuration) {
    if (config) {
        Object.assign(AppGlobals.config, config);
        if (config.stage?.toLowerCase() === 'production') {
            enableProdMode();
        }
    }
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        // tslint:disable-next-line: no-console
        .catch(err => console.log(err));
}

(async () => {
    let finalConfig = configuration as Configuration;
    const stage = finalConfig.stage?.toLowerCase();
    if (stage && !['dev', 'development', 'local'].includes(stage)) {
        try {
            const resp = await fetch('assets/configuration.json', { cache: 'no-cache' });
            if (resp.ok) {
                const remote = await resp.json();
                finalConfig = { ...finalConfig, ...remote };
            } else {
                console.log('Config fetch failed status:', resp.status);
            }
        } catch (e) {
            console.log('Config fetch error:', e);
        }
    }
    startApp(finalConfig);
})();
